import React, { FC, Fragment } from 'react';
import { connect } from 'react-redux';
import { trackNavigationClicked } from 'util/trackingHelper';
import { UniversalTabs } from 'reducers/nav';
import featureFlags from 'util/featureFlags';
import { RootState } from 'reducers/index';
import './UniversalTabList.less';

type UniversalTabListProps = UniversalTabListMapStateProps;

export const UniversalTabListComponent: FC<UniversalTabListProps> = ({ activeUniversalTab }) => {
  // swaps classes on zola footer in web-store with home or wedding zola logo based on which tab has been clicked
  const swapZolaLogos = (tab: UniversalTabs) => {
    const isHomeStoreTab = tab === UniversalTabs.HOME_STORE;
    const footerLogo = document.getElementById('zola-store-logo');
    if (footerLogo && isHomeStoreTab) {
      footerLogo.classList.remove('zola-logo');
      footerLogo.classList.add('zola-store-logo');
    } else if (footerLogo && !isHomeStoreTab) {
      footerLogo.classList.remove('zola-store-logo');
      footerLogo.classList.add('zola-logo');
    }
  };

  const onUniversalTabClick = (tab: UniversalTabs) => () => {
    swapZolaLogos(tab);
    trackNavigationClicked({
      menu_item: tab,
      section: 'UNIVERSAL_TAB',
    });
  };

  const getHref = (tab: UniversalTabs) => {
    switch (featureFlags.getEnvironment()) {
      case 'development':
        return tab === UniversalTabs.WEDDINGS ? 'http://localhost' : 'http://localhost:9000';
      case 'staging':
        return tab === UniversalTabs.WEDDINGS
          ? 'https://qa.zola.com'
          : 'https://qa-homestore.zola.com';
      case 'production':
      default:
        return tab === UniversalTabs.WEDDINGS
          ? 'https://www.zola.com'
          : 'https://homestore.zola.com';
    }
  };

  const handleClassName = (tab: UniversalTabs) => {
    const mappedClassnames = {
      [UniversalTabs.WEDDINGS]: {
        active: 'white',
        inactive: 'inactive-white',
      },
      [UniversalTabs.HOME_STORE]: {
        active: 'active-navy',
        inactive: 'inactive-blue',
      },
    };
    const isActive = activeUniversalTab === tab ? 'active' : 'inactive';

    return `navV2__promotionalBar--universal-nav-tab navV2__universal-nav-tab--${mappedClassnames[tab][isActive]}`;
  };

  return (
    <Fragment>
      <ul className="navV2__promotionalBar--links-container navV2__promotionalBar--links-container-left">
        <li className={handleClassName(UniversalTabs.WEDDINGS)}>
          <a
            className="nav-link universal-tab__link"
            target="_self"
            onClick={onUniversalTabClick(UniversalTabs.WEDDINGS)}
            href={getHref(UniversalTabs.WEDDINGS)}
          >
            Weddings
          </a>
        </li>
        <li className={handleClassName(UniversalTabs.HOME_STORE)}>
          <a
            className="nav-link"
            target="_self"
            href={getHref(UniversalTabs.HOME_STORE)}
            onClick={onUniversalTabClick(UniversalTabs.HOME_STORE)}
          >
            Home Store
          </a>
        </li>
      </ul>
    </Fragment>
  );
};

type UniversalTabListMapStateProps = {
  activeUniversalTab: UniversalTabs;
};
const mapStateToProps = (state: RootState): UniversalTabListMapStateProps => ({
  activeUniversalTab: state.nav.activeUniversalTab,
});

export default connect(mapStateToProps, null)(UniversalTabListComponent);
